import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { destinations } from '../utils/mockData';
import { MapPin, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export const DestinationsSection = () => {
  const { language, t } = useLanguage();

  return (
    <section id="destinations" className="py-24 bg-[#FAF9F7]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 fade-in-up">
          <h2 className="font-serif text-4xl md:text-5xl text-[#2C2C2C] mb-4">
            {t('destinationsTitle')}
          </h2>
          <p className="text-lg text-[#8B7D6B] max-w-2xl mx-auto">
            {t('destinationsSubtitle')}
          </p>
        </div>

        {/* Destinations Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {destinations.map((dest, index) => (
            <Link
              key={dest.id}
              to={`/destinations/${dest.slug}`}
              className="destination-card group fade-in-up block"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="relative overflow-hidden rounded-lg shadow-lg h-80">
                {/* Image */}
                <img
                  src={dest.image}
                  alt={`${dest.name} - India destination`}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                />
                
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                
                {/* Content */}
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <div className="flex items-center space-x-2 mb-2">
                    <MapPin className="h-5 w-5 text-[#C4B5A0]" />
                    <h3 className="font-serif text-2xl">{dest.name}</h3>
                  </div>
                  <p className="text-sm text-white/90 italic mb-3">
                    {language === 'en' ? dest.description : dest.descriptionEs}
                  </p>
                  <div className="flex items-center text-xs text-[#C4B5A0] font-medium">
                    <span>Explore Destination</span>
                    <ArrowRight className="h-4 w-4 ml-1" />
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-12 fade-in-up">
          <p className="text-[#8B7D6B] mb-6">
            Explore our curated tours visiting these incredible destinations
          </p>
          <Link to="/tours">
            <Button className="bg-[#C4B5A0] hover:bg-[#6B4E37] text-white px-8 py-6 text-lg">
              View All Tours
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};